<template>
<div class="col-12">
    <div id="fireworks-container" class="black-screen">
        <div class="message">
            <span class="message-text" v-html="celebrationReason"></span>
      </div>
  </div>
  <div v-if="makeVisibleCurrentAchievements">
    <div v-if="fstrackingData">
        <table class="table table-striped table-dark table-bordered">
            <tbody>
            <tr><td class="table-headings-border" colspan="2" style="text-align:center;color:rgb(61, 61, 234);">My Future-Self Vision Review Performance (last Month):</td></tr>
            <tr v-for="(myfstrk, index) in fstrackingData" :key="index" >
                <td v-if="myfstrk.attempt_count >10"  v-html="formatStreakDisplayHeader(myfstrk)"></td> <td v-if="myfstrk.attempt_count >10" v-html="formatStreakDisplayKudos(myfstrk)"></td></tr>
            </tbody>
        </table>
    </div>
    <div v-if="habittrackingData" >
             <table class="table table-striped table-dark table-bordered">
            <tbody>
            <tr><td class="table-headings-border" colspan="2" style="text-align:center;color:rgb(61, 61, 234);">My Action-Habit Streaks (last Month):</td></tr>
            <tr v-for="(habittrk, index) in habittrackingData" :key="index" >
                <td v-if="habittrk.attempt_count >10"  v-html="formatStreakDisplayHeader(habittrk)"></td> <td  v-if="habittrk.attempt_count >10" v-html="formatStreakDisplayKudos(habittrk)"></td></tr>
            </tbody>
        </table>

    </div>
  </div>
  <div v-if="makeDefaultVisible">
    <div class="card" >
    <h3 style="text-align:center;color:rgb(61, 61, 234);">Welcome {{userdata.name}}. </h3>
    <h4 style="text-align: center;">Your Extraordinary Performance(s) will be celebrated below:</h4>
    <div class="row d-flex justify-content-center"> <!--col-12 mx-auto d-flex-->
       <div class="col-lg-4 col-md-4 col-sm-12 p-2 card m-2"> <p>(But always...)</p>
        <h3 style="text-align: center;">Know your "Why":</h3></div>
       <div class="col-lg-4 col-md-4 col-sm-12 p-2 card m-2"> <img style="max-width:95%;width:90%;" src="/graphs/ExcelOpportunity2.png" /></div>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import Fireworks from 'fireworks-js';
export default {
  data() {
    return {
        celebrationReason: 'some other reason',
        fstrackingData: '',
        habittrackingData: '',
        over50FSReviewData:'',
        over50Habitdata:'',
        makeVisibleCurrentAchievements: false,
        makeDefaultVisible: false,
    }
  },
  props: {
    reason:'',
    userdata:'',
  },
//   beforeMount(){
//     console.log("Doing before mount...");
//     this.celebrationReason = "Because you've decided to lift your game!"
//     },
    mounted() {
    //TODO: Debug this: THE REASON SHOULD DISPLAY AS A HEADLINE IN THE INITIAL FIREWORKS, BUT DOESN'T.
    //IF THERE'S NO REASON, THEN TRACKING DATA SHOULD BE RETRIEVED, AND CELEBRATED, ELSE DEFAULT SHOULD BE DISPLAYED.
    this.celebrateMilestone(this.reason);

  },
  methods: {
    celebrateMilestone(reason){
    this.celebrationReason = reason;
    this.triggerFireworks(reason);
        setTimeout(() => {
            this.getTrackingData();
        }, 20);//TODO: REDUCED THIS TIME TO 20ms, increase to 7000 once fixed (see comment in mounted())
    },
    clearPreviousCanvas() {
        // Select all canvas elements in the current document
        const canvasElements = document.querySelectorAll('canvas');
        // Loop through each canvas element and remove it from the document
        canvasElements.forEach(canvas => {
        canvas.parentNode.removeChild(canvas);
        });
    },
    formatStreakDisplayHeader(myfstrk){
        const streakHeading = `${this.formatDateShort(myfstrk.created_at)} - ${this.formatDateShort(myfstrk.updated_at)}`;
        return  streakHeading + ': ';
    },

    formatStreakDisplayKudos(myfstrk){
        const numStars = Math.floor(myfstrk.attempt_count / 10);
        const starHtmlString = `<img src='/images/yays/yellow-gold-star85.png'>`;
        var finalHtml = '';
        if(numStars < 5) {
            for(var i=1; i<=numStars; i++) {
                finalHtml +=starHtmlString;
            }
        } else {
            finalHtml += `<h4>`+numStars + ' stars!: '+ `<img style="width:200px;" class="yayimage" src='/images/yays/rugby-yay.gif'></h4>`;
        }
        return  finalHtml;
    },

    formatDateShort(dateString) {
        const date = new Date(dateString);
        const formattedDate =  date.toLocaleDateString('en', {
        day: '2-digit',
        month: 'short'
        });
        // console.error(formattedDate);
        return formattedDate;
    },

    triggerFireworks(reason) {
        this.celebrationReason = reason;
        const container = document.getElementById('fireworks-container'); // Adjust the ID as needed
        container.hidden = false;
        const fireworks = new Fireworks(container);
        fireworks.start();
        setTimeout(() => {
            fireworks.stop();
            container.hidden = true;
            this.clearPreviousCanvas(); //else canvas elements keep getting added to the parent, and the fireworks fire lower and lower on the page...!
            this.celebrationReason = "";
        }, 6000); // Adjust the duration as needed
    },

    getTrackingData() {
        axios.post('/homepage/tracking', {
            user_id:this.userdata.id,
        })
        .then(res => {
            this.fstrackingData =JSON.parse(res.data.fstracking);
            this.habittrackingData =JSON.parse(res.data.habittracking);
        })
        .catch(err => {
            console.error(err);
        })
        .finally(()=> {
            // location.reload();
            this.seekReason2Celebrate();
        });
    },

    seekReason2Celebrate(){
        // console.error("Seeking reason to celebrate....");
        this.over50Habitdata = this.habittrackingData.filter((habit) => {
            return habit.attempt_count > 50;
        });
       this.over50FSReviewData = this.fstrackingData.filter((fstrak) => {
            return fstrak.attempt_count > 50;
        });

        if(this.over50Habitdata.length > 0 && this.over50FSReviewData.length > 0) {
            // onsole.error("Found reason to celebrate....Action-Habit");
            this.triggerFireworks("You've Over-50 streaked<br/> an Action-Habit! Woo-hoo!")
            if(this.over50FSReviewData.length > 0) {
                setTimeout(() => {
                        this.triggerFireworks('You reviewed your Future-Self Vision<br/> for an Over-50 streak!');
                        setTimeout(() => {
                            this.makeVisibleCurrentAchievements = true;
                        }, 7000);

                }, 7000);
            }
        } else  if(this.over50FSReviewData.length > 0 && !this.over50Habitdata.length > 0) {
            this.triggerFireworks('You reviewed your Future-Self Vision<br/> for an Over-50 streak!');
            setTimeout(() => {
                this.makeVisibleCurrentAchievements = true;
            }, 7000);
        } else {
            console.log("Doing else.....");
            const container = document.getElementById('fireworks-container'); // Adjust the ID as needed
            container.hidden = true;
            this.makeDefaultVisible = true;
        }


    },
    makeFireworksObj(container) {
    const fireworks = new Fireworks(container, {
        autoresize: true,
        opacity: 0.5,
        acceleration: 1.05,
        friction: 0.97,
        gravity: 1.5,
        particles: 50,
        traceLength: 3,
        traceSpeed: 10,
        explosion: 5,
        intensity: 30,
        flickering: 50,
        lineStyle: 'round',
        hue: {
            min: 0,
            max: 360
        },
        delay: {
            min: 30,
            max: 60
        },
        rocketsPoint: {
            min: 50,
            max: 50
        },
        lineWidth: {
            explosion: {
            min: 1,
            max: 3
            },
            trace: {
            min: 1,
            max: 2
            }
        },
        brightness: {
            min: 50,
            max: 80
        },
        decay: {
            min: 0.015,
            max: 0.03
        },
        mouse: {
            click: false,
            move: false,
            max: 1
        }
    });
    return fireworks;
    },
  },
watch: {
    celebrationReason(newValue) {
            // return; //for debug when the variable changes
         if (newValue === this.elapsedTimeTarget) {
            this.recordFSReview();
            }
    }
}
};
</script>

<style>
.black-screen {
  position: relative;
  background-color: black;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
}

.performance-name {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 16px;
}

#fireworks-container {
  position: relative;
}

.message {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
}

.yayimage {
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  animation: fadeOut 5s forwards;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}

/* @media (max-width: 768px) {
 #yayOverlay.card {
    width: 80vw;
    height: 60vh;
  }
} */
.table-headings-border{
    color:#ffffff;
    font-size:larger;
    text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
}
/*
  @media  (max-width: 768px)  {
    line-height: 2cap;
  } */


</style>
